var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.size,attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke-width":_vm.strokeWidth,"stroke":"currentColor","aria-hidden":"true"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":_vm.path}})])
}
var staticRenderFns = []

export { render, staticRenderFns }